import DeferredTracking from './DeferredTracking';

export default DeferredTracking;
